module.exports = "/_next/static/images/bc2be507de91400ee71cb5b7781452be-hero-xs-1x.jpg.webp";